const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api-realenergy.duckdns.org';
const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL || 'https://dashboard.realenergy.com.br';

async function readApiResponse(response) {
  let data = null;

  try {
    data = await response.json();
  } catch (error) {
    data = null;
  }

  if (!response.ok) {
    throw new Error(data?.message || data?.error || 'Não foi possível concluir a solicitação.');
  }

  return data;
}

export { API_BASE_URL, DASHBOARD_URL, readApiResponse };
